import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import {
  fetchAllTasks,
  fetchTaskById,
  updateRunningTasks,
} from '@store/thunk/task.thunk'
import { poolNewTask, resolveTask } from '@store/actions/task.actions'
import {
  TaskModel,
  TasksAdapterExport,
  TaskState,
} from '@store/slices/task.slice'
import { toast } from 'react-toastify'

export const taskExtraReducers = (
  builder: ActionReducerMapBuilder<TaskState>
) => {
  builder
    // poolRunningTasks
    .addCase(updateRunningTasks.pending, (state) => {
      state.loading = true
      state.error = null
    })
    .addCase(updateRunningTasks.fulfilled, (state, action) => {
      TasksAdapterExport.upsertMany(state, action.payload)
      const finishedTasks = action.payload.map((task) => task.id)
      state.unresolvedTaskIds = [...finishedTasks]
      state.runningTaskIds = [
        ...state.runningTaskIds.filter(
          (taskId) => !finishedTasks.includes(taskId)
        ),
      ]
      state.loading = false
    })
    .addCase(updateRunningTasks.rejected, (state) => {
      state.error = `Nepovedlo se aktualizovat bežící procesy`
      state.loading = false
    })
    // fetchAllTasks
    .addCase(fetchAllTasks.pending, (state) => {
      state.loading = true
      state.error = null
    })
    .addCase(fetchAllTasks.fulfilled, (state, action) => {
      TasksAdapterExport.upsertMany(state, action.payload)
      state.loading = false
    })
    .addCase(fetchAllTasks.rejected, (state) => {
      state.error = `Nepovedlo se stáhnout procesy`
      state.loading = false
    })
    // fetchTaskById
    .addCase(fetchTaskById.pending, (state) => {
      state.loading = true
      state.error = null
    })
    .addCase(fetchTaskById.fulfilled, (state, action) => {
      TasksAdapterExport.upsertOne(state, action.payload)
      state.loading = false
    })
    .addCase(fetchTaskById.rejected, (state) => {
      state.error = `Nepovedlo se aktualizovat bežící procesy`
      state.loading = false
    })
    // poolNewTask
    .addCase(poolNewTask, (state, action) => {
      const newId = action.payload.id
      const relatedObjects = action.payload.relatedObjects
      const title = action.payload.title
      const relatedLink = action.payload.relatedLink
      const task = {
        id: newId,
        relatedObjects,
        title: title,
        relatedLink,
      } as TaskModel

      TasksAdapterExport.addOne(state, task)
      state.runningTaskIds = [...state.runningTaskIds, newId]
      toast.info(`Spouštím úḱol '${title}'`)
    })
    // resolveTask
    .addCase(resolveTask, (state, action) => {
      state.unresolvedTaskIds = [
        ...state.unresolvedTaskIds.filter(
          (taskId) => taskId != action.payload.id
        ),
      ]
    })
}
